export default __webpack_public_path__ + "static/fashion_preview-111fa38621c03d6d9eb39dc37b6e1351.mp4";